import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useAdminCheck = () => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['admin-check'],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session?.user) {
        return { isAdmin: false, userEmail: null };
      }

      const { data: roleData, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', session.user.id)
        .eq('role', 'admin')
        .maybeSingle();

      if (error) {
        console.error('Error checking admin status:', error);
        return { isAdmin: false, userEmail: session.user.email || null };
      }

      return { 
        isAdmin: !!roleData, 
        userEmail: session.user.email || null 
      };
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - admin status rarely changes
    gcTime: 30 * 60 * 1000, // 30 minutes cache
    refetchOnWindowFocus: false,
  });

  // Invalidate on auth state change
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      // Only invalidate on actual sign in/out, not token refresh
      if (event === 'SIGNED_IN' || event === 'SIGNED_OUT') {
        queryClient.invalidateQueries({ queryKey: ['admin-check'] });
      }
    });

    return () => subscription.unsubscribe();
  }, [queryClient]);

  return { 
    isAdmin: data?.isAdmin || false, 
    isLoading, 
    userEmail: data?.userEmail || null 
  };
};
